import React from "react";
import { motion } from "framer-motion";
import { LibraryIcon, BookOpenIcon, LayersIcon, ZapIcon } from "lucide-react";
const stats = [{
  icon: LibraryIcon,
  title: "Más de 300 protocolos clínicos",
  desc: "Todo organizado para encontrar la respuesta que necesitas en minutos."
}, {
  icon: BookOpenIcon,
  title: "6 tomos especializados",
  desc: "Desde el diagnóstico hasta el cierre del tratamiento."
}, {
  icon: LayersIcon,
  title: "Compatible con cualquier marca",
  desc: "Aplica los protocolos sin importar el sistema de alineadores que utilices."
}, {
  icon: ZapIcon,
  title: "Consulta rápida",
  desc: "No tendrás que leer miles de páginas para encontrar una solución."
}];
export function Stats() {
  return <section className="bg-white px-5 py-10" data-id="element-207" data-mp="1q9a20k5mhawd">
      <div className="mx-auto grid max-w-md grid-cols-1 gap-3 xs:grid-cols-2 sm:grid-cols-2" data-id="element-208" data-mp="1qal0q5k7nsgm">
        {stats.map((s, i) => <motion.div key={s.title} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className="rounded-2xl border border-navy-100 bg-navy-50 p-4" data-id="element-209" data-mp="1vah4c3ozxhvn" data-mpi={i}>
            <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-brand text-white" data-id="element-210" data-mp="e43eopwntolq">
              <s.icon className="h-5 w-5" data-id="element-211" data-mp="3iknsvbhvxtvm" />
            </div>
            <h3 className="font-display text-sm font-bold leading-snug text-navy-800" data-id="element-212" data-mp="3il5yuzucnmgq">{s.title}</h3>
            <p className="mt-1.5 text-xs leading-relaxed text-navy-800/60" data-id="element-213" data-mp="3dne5e1e23saf">{s.desc}</p>
          </motion.div>)}
      </div>
    </section>;
}